exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mix__chart h3[data-v-35811485]{font-weight:600;font-size:1.4285714286em}.chart__wrapper[data-v-35811485]{padding:15px 0px 15px 15px}.chart__wrapper h3[data-v-35811485]{font-family:Lora,serif;color:#3e5473;font-size:1.1428571429em;margin-bottom:18px}", ""]);

